import IconMoreOptions from '@deprecated-ui/common/IconMoreOptions';
import Text from '@deprecated-ui/common/Text';
import Button from '@deprecated-ui/common/Button';
import Iconmoon from '@deprecated-ui/common/Iconmoon';
import color from '@deprecated-ui/_style/color';
import styled from 'styled-components';

interface CompanySymbolProps {
  valueType?: string;
}

const IconMore = styled(IconMoreOptions)`
  border: 1px solid ${color.gainsboro};
  border-left: none;
  height: 30px;
  padding: 2px 4px;
`;

const OptionItem = styled(Text).attrs({
  as: 'a',
  height: '28px',
  padding: '0 10px',
})`
  display: block;
  :hover {
    background: ${color.whisper};
  }
`;

// This container will be replaced with chart plotter library
const PlainChart = styled.div`
  height: 200px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid ${color.gainsboro};
`;

const CompanySymbol = styled.div.attrs<CompanySymbolProps>((props) => ({
  valueType: props.valueType || 'none',
}))<CompanySymbolProps>`
  background: ${color.highempahis};
  border-left: 5px solid ${(props) => props.valueType};
  height: 30px;
  border-radius: 2px;
`;

const ButtonFooter = styled(Button).attrs({ height: '30px' })`
  display: flex;
  flex: 1 1 auto;

  border-left: 0;
  border-bottom: 0;
  :last-child {
    border-right: 0;
  }

  &:hover,
  &:focus {
    border-left: 0;
    border-bottom: 0;
  }
`;
const IconStockChange = styled(Iconmoon)`
  line-height: 1;
  font-size: 14px;

  &.icon-symbol_up:before {
    content: '\\25B2';
    display: inline-block;
    font-size: 13px;
    padding-bottom: 4px;
    padding-left: 5px;
  }
  &.icon-symbol_down:before {
    content: '\\25BC';
    display: inline-block;
    font-size: 12px;
    padding-bottom: 4px;
    padding-left: 5px;
  }
`;

const TextAbout = styled(Text).attrs({
  height: '21px',
})`
  word-break: break-word;
  max-height: 90px;
  overflow: hidden;
  min-height: 50px;
  margin-top: 10px;
  margin-bottom: 10px;
`;

const EmptyChartContainer = styled.div`
  background: ${color.light};
  border: none;
  margin-bottom: 0;
  padding: 10px 10px 11px;
`;

const EmptyChartText = styled(Text).attrs({
  size: '13px',
  color: color.highgray,
})`
  text-align: center;
  margin-top: 18px;
`;

const SuspendedBadge = styled.div`
  display: flex;
  padding: 2px 5px;
  color: ${color.sunsetOrange};
  border: 1px solid rgba(238, 74, 73, 0.5);
  border-radius: 2px;
`;

export {
  IconMore,
  OptionItem,
  PlainChart,
  CompanySymbol,
  ButtonFooter,
  IconStockChange,
  TextAbout,
  EmptyChartContainer,
  EmptyChartText,
  SuspendedBadge,
};
